let _this, video, canvas, context, mediaStreamTrack,videoWidth,videoHeight;
$(function () {
  $(document).on('change', '#pro-uploadImg', function (e) {
    let acceptTypeArr = ["image/png","image/x-png","image/jpeg"];
    let file = $(this)[0].files[0];
    if (file && file.size > 20480 && file.size <= _this.faceSize * 1048576 && acceptTypeArr.indexOf(file.type) > -1) {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = window.URL.createObjectURL($(this)[0].files[0]);
      img.onload = function(e){ 
        if (this.width >= 150 && this.width <= 4096 && this.height >= 150 && this.height <= 4096) {
          let reader = new FileReader();
          reader.onload = function(e) {
            _this.cameraPath = e.target.result;
            _this.cameraModal = true;//打开剪切弹窗
            _this.cropperModel = true;
            $('#pro-images').cropper('replace',e.target.result,false );
            _this.$nextTick(function () {
              _this.initCropper();
            })
          };
          _this.fileName = file.name; //加入时间戳避免重复上传同一张图片时，名称相同页面刷新失败的问题
          reader.readAsDataURL(file);
        }else{
          $('#pro-uploadImg').val('');
          _this.messageNotice('error', _this.common.errMsg);
        }
      }    
    }else{
      $('#pro-uploadImg').val('');
      _this.messageNotice('error', _this.common.errMsg);
    }
  });
});

import faceDetection from '../userCommon/userDetectionByFace.vue'
export default {
  name: "camera-and-upload",
  components:{faceDetection},
  props:{
    userInfo:{
      type:Object,
      default(){
        return {
          faceFileBase64:''
        };
      }
    },
    showPorTip:{
      type:Boolean,
      default:false,
    },
    useImgBg:{//是否使用默认头像，不需要的时候用加号
      type:Boolean,
      default:false,
    },
    showUploadText:{//在默认头像上显示uploada文本
      type:Boolean,
      default:false,
    },
    width:{//图片框的宽度
      type:String,
      default:'104px'
    },
    height:{//图片框的高度
      type:String,
      default:'138px'
    },
    direction:{
      type:String,
      default:'left'
    },
    userType:{//人脸是否必填
      type:Number,
      default:0,
    },
    userACData:{
      type:Array,
      default(){
        return [];
      }
    },
    tempAccessData:{
      type:Array,
      default(){
        return [];
      }
    },
    viewInfo:{
      type:Object,
      default(){
        return {};
      }
    },
    value:{
      type:String,
      default(){
        return {};
      }
    },
    frPhoto:{
      type:String,
      default(){
        return {};
      }
    },
  },
  data(){
    return{
      isCamera:false,//是否是拍照
      cameraModal:false,//是否打开弹窗
      cropperModel:false,//是否上传相关显示
      cameraPath:'',
      photoFlag:false,
      closable:false,
      fileName:'visitorFace',
      faceSize:window.g.uploadFaceSize,
      necessaryFace:false,/*必填*/
      showFace:true,/*显示*/

      sameUserCount:0,
      detectionStatus:-1,
      cancelFun:'',
      enableFaceDup:false,/* 开启人脸去重 */
    }
  },
  mounted(){
    _this = this;
    this.initInfo();
    this.getFaceDupSetting();
   
  },
  watch:{
    'cameraModal':{
      handler(nv, ov){
        if(nv === false){
          mediaStreamTrack && mediaStreamTrack.stop();
          $('#pro-uploadImg').val('');
        }
      }
    },
  },
  methods:{
    initInfo:function () {
     
      if (_this.userType > -1) {
       switch (_this.userType){
        case 0:
          _this.necessaryFace = _this.ApiService.mustWrite.Staff;
          _this.showFace = _this.ApiService.judgmentSwitch.Staff;
          break;
        case 1:
          _this.necessaryFace = _this.ApiService.mustWrite.Visitor;
          _this.showFace = _this.ApiService.judgmentSwitch.Visitor;
          break;
        case 2:
          _this.necessaryFace = _this.ApiService.mustWrite.Vendor;
          _this.showFace = _this.ApiService.judgmentSwitch.Vendor;
          break;
        default:
          _this.necessaryFace = _this.ApiService.mustWrite.Tenant;
          _this.showFace = _this.ApiService.judgmentSwitch.Tenant;
          break;
      }
      } else {
        _this.showFace = true;
      }
    },
    //选择上传人脸方式
    selectUploadMthPro:function (e) {
      if(_this.direction === 'right'){
        let width = $('.add-user-photo-bg').width();
        if($(e.target).hasClass('add-user-photo-bg') || $(e.target).hasClass('user-face') || $(e.target).hasClass('replace-btn')){
          $('.pro-upload-face-method').fadeIn().css({right:(width - e.offsetX + 3) + 'px', bottom: '', top: $(e)[0].offsetY});
          $('.upload-face-way').fadeOut();
        }
      }else{
        if($(e.target).hasClass('add-user-photo-bg') || $(e.target).hasClass('user-face') || $(e.target).hasClass('replace-btn')){
          $('.pro-upload-face-method').fadeIn().css({left:e.offsetX -88 + 'px', bottom: '', top: $(e)[0].offsetY});
          $('.upload-face-way').fadeOut();
        }
      }
    },
    //选择上传方式
    uploadImgPro:function(e){
      e.stopPropagation();
      _this.isCamera = false;
      $('.pro-upload-face-method').fadeOut();
      $('#pro-uploadImg').click();
    },
    //录入人脸
    camera:function () {
      this.cameraModal = true;
      this.cropperModel = false;
      this.isCamera = true;
      this.$nextTick(()=>{
        _this.init();
      })
    },

    //点击确认按钮拍照
    trickImg:function () {
      //绘制画面
      context.drawImage(video, 0, 0, videoWidth, videoHeight);
      mediaStreamTrack.stop();
      $('#pro-videoUser').hide();
      _this.cropperModel = true;
      _this.cameraPath = canvas.toDataURL("image/jpeg");
      $('#pro-images').cropper('replace',canvas.toDataURL("image/jpeg"),false );
      _this.$nextTick(()=>{
        _this.initCropper();
      });
      _this.fileName = 'face' + new Date(_this.moment()).getTime();
      console.log("1211111",_this.fileName);

    },
    // 图片上传
    cropperImgPro:function (type) {
      let cas = $('#pro-images').cropper('getCroppedCanvas');
      let base64url = cas.toDataURL('image/jpeg');
      _this.cameraModal = false;
      let url = base64url.split(',')[1];
      _this.$emit('input', url);
      _this.$emit('showTips','');
      if(_this.$parent.clearFileId){
        _this.$parent.clearFileId()
      }else{
        _this.$parent.$parent.clearFileId();
      }
    },
    //删除头像
    deleteFacePhoto:function(){
      _this.$set(_this.userInfo,"faceFlag",false);
      _this.$emit('input', '');
      _this.$forceUpdate();
      _this.detectionStatus = -1;
      if(_this.$parent.clearFileId){
        _this.$parent.clearFileId()
      }else{
        _this.$parent.$parent.clearFileId();
      }
    },
    //重新选取图片
    RemakeUploadFile:function(){
      $('#pro-uploadImg').val('');
      $('#pro-uploadImg').click();
      _this.detectionStatus = -1;
    },

    initCropper:function () {
      $('#pro-images').cropper({
        aspectRatio: 3 / 4,
        viewMode:1,
        preview:".small",
        background:false,
        autoCropArea:1
      });
    },

    rotateLeft:function () {
      $('#pro-images').cropper('rotate', 90);
    },

    rotateRight:function () {
      $('#pro-images').cropper('rotate', -90);
    },

    plus:function () {
      $('#pro-images').cropper('zoom', 0.1);
    },

    mini:function () {
      $('#pro-images').cropper('zoom', -0.1);
    },

    rotateReset:function () {
      $('#pro-images').cropper('reset');
    },

    //剪切摄像拍照头像
    init:function () {
      $('#pro-videoUser').show();
      //访问用户媒体设备的兼容方法
      function getUserMedia(constrains,success,error){
        if(navigator.mediaDevices.getUserMedia){
          //最新标准API
          navigator.mediaDevices.getUserMedia(constrains).then(success).catch(error);
        } else if (navigator.webkitGetUserMedia){
          //webkit内核浏览器
          navigator.webkitGetUserMedia(constrains).then(success).catch(error);
        } else if (navigator.mozGetUserMedia){
          //Firefox浏览器
          navagator.mozGetUserMedia(constrains).then(success).catch(error);
        } else if (navigator.getUserMedia){
          //旧版API
          navigator.getUserMedia(constrains).then(success).catch(error);
        }
      }

      video = document.getElementById("pro-videoUser");
      canvas = document.getElementById("pro-canvasUser");

      canvas.style.width = 720 + "px";
      canvas.style.height = 420 + "px";
      context = canvas.getContext("2d");

      //成功的回调函数
      function success(stream){
        //兼容webkit内核浏览器
        let CompatibleURL = window.URL || window.webkitURL;
        //将视频流设置为video元素的源
        mediaStreamTrack = stream.getTracks()[0];
        video.srcObject = stream;
        video.addEventListener('canplay', function() {
          videoWidth = this.videoWidth;
          videoHeight = this.videoHeight;
          canvas.width = videoWidth;
          canvas.height = videoHeight;
        });
        //播放视频
        video.play();
      }

      //异常的回调函数
      function error(error){
        _this.messageNotice('error', "Failed to access user media device:" + error.message);
      }
      if (navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia){
        //调用用户媒体设备，访问摄像头
        getUserMedia({
          video:{width:1920,height:1080}
        },success,error);
      } else {
        _this.messageNotice('error', "Your browser does not support accessing user media devices");
      }
    },

    // 人脸检索
    sameFaceSearch: function () {
      if(!this.enableFaceDup){
        return;
      }
      let cancelToken = new _this.$ajax.CancelToken(function executor(c) {
        _this.cancelFun = c;
      });
      _this.detectionStatus = 0;/* 检测中 */
      let pragram = {
        faceImageBase64:JSON.stringify(this.userInfo.faceFileBase64)
      }
      if(_this.$root.curOfficeInfo.id) {
        pragram.officeIds = [_this.$root.curOfficeInfo.id]
      }
      this.$ajax.post('User/EditVeriface',pragram,{headers:{noLoading:true,'Content-Type':'application/json'},cancelToken:cancelToken}).then(function (res) {
        if(res.data.success && res.data.data.result !== 5){
          let result = res.data.data ? res.data.data.items : [];
          if (result && result.length > 0) {
            // 移除当前用户
            let index = result.findIndex(item => item.id === _this.$route.query.userId);
            if (index > -1) {
              result.splice(index, 1);
            }
            if (result && result.length > 0){
              _this.detectionStatus = 1;/* 检测成功，存在相似人脸的人 */
              _this.shareApi.getUserList({enabledPaging: false,sortName:'name',sortType:1,ids:result.map(item =>item.id)}).done(users =>{
                _this.sameUserCount = users.items.length;
                _this.$refs.userDetected.sameIdList = users.items;
                _this.$refs.userDetected.idSearchModal = true;
              });
            }else{ /* 搜出来的人是当前编辑的人 */
              _this.detectionStatus = 2;
            }
          }else{
            _this.detectionStatus = 2;
          }          
        }else{
          _this.sameUserCount = 0;
          _this.detectionStatus = 3;
        }
      })
    },
    stopDetection(){
      if(_this.cancelFun){
        _this.cancelFun();
      }
      _this.detectionStatus = (_this.detectionStatus === 0 ? -1 : _this.detectionStatus);
    },
    // 获取人脸去重配置
    getFaceDupSetting(){
      let userType = this.$route.meta.thirdMenu;
      let obj = {'Staff':0,'Vendor':2,'Tenant':3};
      let currentType = obj[userType];
      if((currentType || currentType === 0) && _this.ApiService.faceDupInfo.usertTypes.indexOf(currentType)> -1){
        _this.enableFaceDup = true;
      }
    },
    openDetectionModal(){
      _this.$refs.userDetected.idSearchModal = true;
    },
    // 复制 FR photo 
    copyImg:function(){
      let frp=_this.frPhoto
      _this.$emit('input', frp);
      _this.$emit('showTips','');
      if(_this.$parent.clearFileId){
        _this.$parent.clearFileId()
      }else{
        _this.$parent.$parent.clearFileId();
      }
    }   
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/fastRegistration/profilePhotoUpload.js